export class FiltroConsistenciaConsumidor {

    consumidorId: number;
    areaId: number;

    constructor(consumidorId: number, areaId : number) {
        this.consumidorId = consumidorId;
        this.areaId = areaId;
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-consistencia-consumidor.ts